import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {
  CalendarFilterClear,
  CalendarFiltersActionTypes,
  CalendarFilterSet
} from './actions';
import { FilterService } from '../../helpers/filters/filter-service';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { selectCalendarFiltersState, SharedState } from '../reducer';
import { CalendarFiltersState } from './state';

@Injectable()
export class CalendarFilterEffects {
  
  public filterClear$: Observable<CalendarFilterSet> = createEffect(() => this.actions$.pipe(
    ofType(CalendarFiltersActionTypes.ClearFilter),
    withLatestFrom(this.store.pipe(select(selectCalendarFiltersState))),
    switchMap(
      ([action, state]: [CalendarFilterClear, CalendarFiltersState]) => {
        const change = this.filterService.filterClear(action.payload, state);
        return of(new CalendarFilterSet(change));
      }
    )
  ));

  constructor(
    public filterService: FilterService,
    private actions$: Actions,
    private store: Store<SharedState>
  ) {}
}
